import { aiProcessData } from "@/mocks/aiSolutionsData";
import AnimatedSection from "@/components/AnimatedSection";

export default function AiProcessSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none grid-pattern" />
      <div className="container-astro relative z-10">
        <AnimatedSection>
          <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-3 font-heading tracking-tight">
              {aiProcessData.heading}
            </h2>
            <div className="w-16 h-1 rounded-full mx-auto bg-gradient-to-r from-[#2563EB] via-[#7C3AED] to-[#F97316]" />
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              {aiProcessData.subtext}
            </p>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {aiProcessData.steps.map((step, i) => (
            <AnimatedSection key={step.number} delay={i * 80}>
              <div className="h-full relative rounded-2xl border border-background-200/80 bg-background-50 p-6 card-lift hover:border-accent-200">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-3xl font-extrabold font-heading gradient-text">
                    {step.number}
                  </span>
                  <span className="w-9 h-9 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-sparkling-line" />
                    </span>
                  </span>
                </div>
                <h3 className="text-base font-bold text-foreground-950 font-heading mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {step.desc}
                </p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}